// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/project/bg_2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insights_main_section__5oJj0 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 67vh;
  max-width: 100%;
  margin: 0;
  padding: 0;

  .insights_heroSection__XrsrK {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 4rem 0;
  }
}

.insights_tabs_container__ljGKz {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 1rem 0;
}

.insights_tab__PMvNn {
  font-family: inter;
  background-color: var(--text-color);
  text-align: center;
  padding: 1rem;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  font-weight: bold;
}

.insights_activeTab__9qMQ9 {
  background-color: var(--primary-color);
  color: var(--text-color);
  font-weight: bold;
}

.insights_tab_content__8AIwe {
  margin: 1.2rem 0 1rem;

  & img {
    max-width: 100%;
    height: auto;
  }
}

.insights_right_content__W5Rsy {
  margin: 1.2rem 0 1rem;

  & h1 {
    font-family: Inter;
    font-size: 2.1rem;
    font-weight: 700;
  }

  & p {
    font-family: Inter;
    font-size: 1rem;
    font-weight: 500;
  }

  & a {
    font-family: Inter;
    font-size: 1rem;
    font-weight: 500;
    line-height: 19.37px;
    color: var(--primary-color);
  }
}

.insights_card__c2OGO {
  margin: 1rem 0;

  & img {
    max-width: 100%;
    height: auto;
  }

  & h5 {
    padding-top: 1.2rem;
    font-family: Inter;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.3rem;
  }

  & p {
    font-family: Inter;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.2rem;
  }

  & a {
    font-family: Inter;
    font-size: 1rem;
    font-weight: 500;
    line-height: 19.37px;
    color: var(--primary-color);
  }
}


/* -----------details_sec----------- */

.insights_details_sec__oPuAA{
  
}


/* --------media-queris----------- */

@media screen and (max-width: 568px) {
  .insights_tabs_container__ljGKz {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }

  br {
    display: none;
  }

  .insights_right_content__W5Rsy h1 {
    font-size: 1.5rem;
  }

  .insights_card__c2OGO {
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Insights/insights.module.css"],"names":[],"mappings":"AAAA;EACE,yDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;;EAEV;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;;EAErB;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;;EAEd;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;EAC7B;AACF;;;AAGA,sCAAsC;;AAEtC;;AAEA;;;AAGA,oCAAoC;;AAEpC;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/project/bg_2.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 67vh;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .heroSection {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    margin: 4rem 0;\n  }\n}\n\n.tabs_container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  padding: 1rem 0;\n}\n\n.tab {\n  font-family: inter;\n  background-color: var(--text-color);\n  text-align: center;\n  padding: 1rem;\n  cursor: pointer;\n  border: 1px solid #d9d9d9;\n  font-weight: bold;\n}\n\n.activeTab {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n  font-weight: bold;\n}\n\n.tab_content {\n  margin: 1.2rem 0 1rem;\n\n  & img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.right_content {\n  margin: 1.2rem 0 1rem;\n\n  & h1 {\n    font-family: Inter;\n    font-size: 2.1rem;\n    font-weight: 700;\n  }\n\n  & p {\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  & a {\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 19.37px;\n    color: var(--primary-color);\n  }\n}\n\n.card {\n  margin: 1rem 0;\n\n  & img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  & h5 {\n    padding-top: 1.2rem;\n    font-family: Inter;\n    font-size: 1.2rem;\n    font-weight: 700;\n    line-height: 1.3rem;\n  }\n\n  & p {\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.2rem;\n  }\n\n  & a {\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 19.37px;\n    color: var(--primary-color);\n  }\n}\n\n\n/* -----------details_sec----------- */\n\n.details_sec{\n  \n}\n\n\n/* --------media-queris----------- */\n\n@media screen and (max-width: 568px) {\n  .tabs_container {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: 10px;\n  }\n\n  br {\n    display: none;\n  }\n\n  .right_content h1 {\n    font-size: 1.5rem;\n  }\n\n  .card {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `insights_main_section__5oJj0`,
	"heroSection": `insights_heroSection__XrsrK`,
	"tabs_container": `insights_tabs_container__ljGKz`,
	"tab": `insights_tab__PMvNn`,
	"activeTab": `insights_activeTab__9qMQ9`,
	"tab_content": `insights_tab_content__8AIwe`,
	"right_content": `insights_right_content__W5Rsy`,
	"card": `insights_card__c2OGO`,
	"details_sec": `insights_details_sec__oPuAA`
};
export default ___CSS_LOADER_EXPORT___;
